export * from "./masthead-description.component";
